import { render, staticRenderFns } from "./DevelopmentDegreeIP.vue?vue&type=template&id=cabb2e98"
import script from "./DevelopmentDegreeIP.vue?vue&type=script&lang=js"
export * from "./DevelopmentDegreeIP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports